import React from "react";
import { FormLabel, Grid } from "@mui/material";
import NumberEditor from "../inputs/numberEditor";
import { GetLineItemPrecision } from "../../sharedCode/HelperMethods";
import Box from "@mui/material/Box";
import { ExtendTicketLineItem, TicketLineItemExtended } from "../../Utils/TypeExtensions";
import { QUANTITY_TYPE_AMOUNT } from "../../sharedCode/metadata";
import StringEditor from "../inputs/stringEditor";
import { TicketProps } from "../../FlightPackage/Ticket/FlightLegs/ticketFlightLegs";
import { TicketLineItem } from "../../sharedCode/avroGraphql";

interface Props extends TicketProps {
    lineItemTypeId: number;
    mergeRowChanges: (lineItemId: number, changes: Record<string, unknown>) => void;
}

// NB per diems are dynamically inserted/deleted so to support this we pass the line_item_type_id into the controls to let the merge method know what per diem type to create
export default function PerDiemsRow(props: Props): JSX.Element {
    const lineItem = getLineItemForType(props.lineItemTypeId) as TicketLineItemExtended;
    const lineItemType = props.lineItemTypeList.find((t) => t.id === props.lineItemTypeId);

    if (!lineItem || !lineItemType) return <></>;

    function getLineItemForType(lineItemTypeId: number) {
        let itemToUpdate = props.ticket.LineItems?.find((l) => l?.line_item_type_id === lineItemTypeId);

        if (!itemToUpdate) {
            itemToUpdate = ExtendTicketLineItem({
                id: props.ticket.nextLocalId,
                line_item_type_id: lineItemTypeId,
                quantity_type_id: QUANTITY_TYPE_AMOUNT,
            } as TicketLineItem);
        }

        return itemToUpdate;
    }

    return (
        <Grid container flexDirection={"row"} spacing={1} alignItems={"center"}>
            <Grid xs={4} sm={5} item>
                <Box flexDirection={"row"} sx={{ ml: 2.0, mt: 1.8, mb: 1.4, width: "100%" }}>
                    <FormLabel>{lineItemType.label.toLocaleUpperCase()}</FormLabel>
                </Box>
            </Grid>
            <Grid xs={4} sm={5} flex={1} item>
                <StringEditor
                    sourceId={lineItem.line_item_type_id}
                    sourceProperty="comments"
                    labelText="COMMENTS"
                    isRequired={false}
                    initialValue={lineItem.comments}
                    mergeChanges={props.mergeRowChanges}
                    isDisabled={props.isReadOnly}
                    errors={props.errors}
                    containerUrl={"ticket/perdiems"}
                />
            </Grid>
            <Grid xs={4} sm={2} item>
                <NumberEditor
                    sourceId={lineItem.line_item_type_id}
                    sourceProperty="quantity"
                    labelText="QUANTITY"
                    isRequired={false}
                    initialValue={lineItem.quantity}
                    mergeChanges={props.mergeRowChanges}
                    isDisabled={props.isReadOnly}
                    errors={props.errors}
                    containerUrl={"ticket/perdiems"}
                    precision={GetLineItemPrecision(lineItem.line_item_type_id)}
                />
            </Grid>
        </Grid>
    );
}
